// extracted by mini-css-extract-plugin
module.exports = {"glowingImage":"Details_glowingImage__RfHlt","learnMoreButton":"Details_learnMoreButton__Rx1Dt"};